import { GET_PROGRAMS } from "constants/programs";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_PROGRAMS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
